(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('news', {
            parent: 'app',
            url: '/news',
            data: {
                authorities: [],
                pageTitle: 'global.menu.news'
            },
            views: {
                'content@': {
                    templateUrl: 'app/news/news.html',
                    controller: 'NewsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('news');
                    return $translate.refresh();
                }]
            }
        })
        .state('news-view', {
            parent: 'news',
            url: '/news-view/{filename}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/news/news-view.html',
                    controller: 'NewsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    keyboard: false,
                    resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('news');
                        return $translate.refresh();
                    }]
                    }
                }).result.then(function() {
                    $state.go('news', null, {});
                }, function() {
                    $state.go('news');
                });
            }]
        });
      }
})();
